window.jQuery = window.$ = require('jquery/dist/jquery.js');
require('nanoscroller/bin/javascripts/jquery.nanoscroller.js');
require('dotdotdot/src/js/jquery.dotdotdot.js');
require('owl-carousel-2/owl.carousel.js');
require('owl-carousel-2/assets/owl.carousel.css');
require('jquery.inputmask/dist/jquery.inputmask.bundle.js');

$(window).bind('load', function() {

	$(".masked-date").inputmask("99/99/9999",{showMaskOnHover: false });
	$(".masked-phone").inputmask("+9 (999) 999-9999",{showMaskOnHover: false });
	$('.masked-email').inputmask({
	    mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
	    greedy: false,
	    showMaskOnHover: false,
	    onBeforePaste: function (pastedValue, opts) {
	      pastedValue = pastedValue.toLowerCase();
	      return pastedValue.replace("mailto:", "");
	    },
	    definitions: {
	      '*': {
	        validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
	        cardinality: 1,
	        casing: "lower"
	      }
	    }
	  });

	$(document).on('click', '.btn-share', function(){
	    Share.go(this);
	});

	$('.tabsFix-title').click(function () {
		var id = $(this).index();
		$('.tabsFix-content-list').fadeIn();
		$('.tabsFix-content').eq(id).slideDown();
	});


	$('.tabsFix-content-title').click(function () {
		$('.tabsFix-content-list').fadeOut();
		$('.tabsFix-content').slideUp();
	});

	$('.contact-map-link').click(function () {
		$('.map').css('z-index','4');
	});

	$('.map-close').click(function () {
		$('.map').css('z-index','');
	});

	$('.content-menu-dropdown-title').click(function () {
		$(this).parents('.content-menu-dropdown').toggleClass('open').find('.content-menu-dropdown-block').stop().slideToggle();
	});

	$('.content-menu-dropdown-block a').click(function () {
		$(this).parents('.content-menu-dropdown').toggleClass('open').find('.content-menu-dropdown-block').stop().slideToggle();
	});

	$('.btn-fix-footer').click(function () {
		if($(this).hasClass('open')) {
			$('body').css('overflow','');
		} else {
			$('body').css('overflow','hidden');
		}
		$(this).toggleClass('open');
		$('.block-fix-footer').stop().fadeToggle();
	});

	$('#menu-btn').click(function () {
		$(this).toggleClass('active');
		$('body').toggleClass('menu-active');
		$('#btn-search').removeClass('active');
		$('#search').removeClass('active');
		$('#btn-functions-callback').removeClass('open');
		$('#functions-callback').hide();
	});

	$('#blackhole-menu').click(function () {
		$('#menu-btn').toggleClass('active');
		$('body').toggleClass('menu-active');
		$('#btn-search').removeClass('active');
		$('#search').removeClass('active');
		$('#btn-functions-callback').removeClass('open');
		$('#functions-callback').hide();
	});

	$('#btn-search').click(function () {
		$(this).toggleClass('active');
		$('#search').toggleClass('active');
		$('#btn-functions-callback').removeClass('open');
		$('#functions-callback').hide();
	});

	$('#btn-functions-callback').click(function () {
		$(this).toggleClass('open');
		$('#functions-callback').fadeToggle();
		$('#btn-search').removeClass('active');
		$('#search').removeClass('active');
	});

		// Перезагрузка при повороте экрана
	$('html,body').on("orientationchange",function(){
        $('#btn-functions-callback').removeClass('open');
		$('#functions-callback').fadeOut();
		$('#btn-search').removeClass('active');
		$('#search').removeClass('active');
    });
    window.addEventListener("orientationchange", function() {
        $('#btn-functions-callback').removeClass('open');
		$('#functions-callback').fadeOut();
		$('#btn-search').removeClass('active');
		$('#search').removeClass('active');
    }, false);

	//POPUP

	$('.btn-popup').click(function (e) {
		e.preventDefault();
		$('#menu-btn').removeClass('active');
		$('body').removeClass('menu-active');
		$('#btn-functions-callback').removeClass('open');
		$('#functions-callback').hide();


		$('#btn-search').removeClass('active');
		$('#search').removeClass('active');
		$('#btn-functions-callback').removeClass('open');
		$('#functions-callback').hide();

		$('body').css('overflow','hidden');
		$('#blackhole').fadeIn();
		var href = $(this).attr('href');
		$(href).fadeIn();
	});

	$('.popup-close').click(function (e) {
		e.preventDefault();
		$('body').css('overflow','');
		$('#blackhole').fadeOut();
		$(this).parents('.popup').fadeOut();

		$('input[type="text"], input[type="password"], textarea').val('');
	});

	$(document).mouseup(function (e){ // событие клика по веб-документу
		var div = $(".popup, .btn-fix-footer, #search, #btn-search, #btn-functions-callback"); // тут указываем ID элемента
		if (!div.is(e.target) // если клик был не по нашему блоку
		&& div.has(e.target).length === 0) { // и не по его дочерним элементам
			$('body').css('overflow','');
			$('#blackhole').fadeOut();
			$('.popup').fadeOut();



			$('#btn-search').removeClass('active');
			$('#search').removeClass('active');
			$('#btn-functions-callback').removeClass('open');
			$('#functions-callback').hide();

			$('.popup input[type="text"], .popup input[type="password"], .popup textarea').val('');
		}
	});

	//END POPUP

	var indexSlider = $('#indexSlider-carousel');

	indexSlider.owlCarousel({
		loop:true,
		items: 1,
		margin: 0,
		stagePadding: 0,
		smartSpeed: 600,
		dots: true,
		nav: false,
		dotsContainer: '#indexSlider-dots'
	});

	$('#indexSlider-next').click(function(){
		indexSlider.trigger('next.owl.carousel');
	});

	$('#indexSlider-prev').click(function(){
		indexSlider.trigger('prev.owl.carousel');
	});


		var applyingCarousel = $('#applyingCarousel');

		if($('#applyingCarousel .applying-item').length == 2){
			$(".applying-wrapper.carousel-block").addClass('static-block-2');
		}else{
			if($('#applyingCarousel .applying-item').length == 3){
				$(".applying-wrapper.carousel-block").addClass('static-block-3');
			}else{
				if($('#applyingCarousel .applying-item').length == 1){
					applyingCarousel.parent().hide();
					$('.applying-wrapper.static-block-1').show();
				}
			}
		}

		applyingCarousel.owlCarousel({
			//loop:true,
			items: 3,
			margin: 0,
			stagePadding: 0,
			smartSpeed: 600,
			dots: false,
			nav: true,
			navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
			navContainer: '#applyingCarousel-nav',
			responsive : {
				0 : {
					items: 1,
					nav: false,
					dots: true
				},
				600 : {
					items: 2,
					nav: false,
					dots: true
				},
				1000 : {
					items: 3,
					dots: false,
					nav: true,
					navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
					navContainer: '#applyingCarousel-nav'
				},
				1300 : {
					items: 3,
					dots: false,
					nav: true,
					navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
					navContainer: '#applyingCarousel-nav'
				}
			}
		});


	var applyingCarouselDetail = $('#applyingCarouselDetail');

	if($('#applyingCarouselDetail .applying-item').length == 2){
		$(".applying-wrapper.carousel-block").addClass('static-block-2');
	}else{
		if($('#applyingCarouselDetail .applying-item').length == 3){
			$(".applying-wrapper.carousel-block").addClass('static-block-3');
		}else{
			if($('#applyingCarouselDetail .applying-item').length == 1){
				applyingCarouselDetail.parent().hide();
				$('.applying-wrapper.static-block-1').show();
			}
		}
	}

	applyingCarouselDetail.owlCarousel({
		//loop:true,
		items: 3,
		margin: 0,
		stagePadding: 0,
		smartSpeed: 600,
		dots: false,
		nav: true,
		navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
		navContainer: '#applyingCarouselDetail-nav',
		responsive : {
			0 : {
				items: 1,
				nav: false,
				dots: true
			},
			600 : {
				items: 2,
				nav: false,
				dots: true
			},
			1000 : {
				items: 2,
				dots: false,
				nav: true,
				navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
				navContainer: '#applyingCarouselDetail-nav'
			},
			1300 : {
				items: 3,
				dots: false,
				nav: true,
				navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
				navContainer: '#applyingCarouselDetail-nav'
			}
		}
	});

	var productCarusel = $('#productCarusel');
	console.log($('#productCarusel .product').length);
	if($('#productCarusel .product').length === 1){
		productCarusel.addClass("width-for-1-el");
	}else{
		if($('#productCarusel .product').length === 2){
			productCarusel.addClass("width-for-2-el");
		}
	}

	productCarusel.owlCarousel({
		loop:false,
		items: 3,
		margin: 0,
		stagePadding: 0,
		smartSpeed: 600,
		dots: false,
		nav: false,
		navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
		responsive : {
			0 : {
				items: 1,
				dots: true
			},
			600 : {
				items: 2,
				dots: true
			},
			1000 : {
				items: 2,
				dots: false,
			},
			1300 : {
				items: 3,
				dots: false,
			}
		}
	});

	var reviewCarousel = $('#reviewCarousel');

	reviewCarousel.owlCarousel({
		loop:true,
		items: 1,
		margin: 0,
		stagePadding: 0,
		smartSpeed: 600,
		dots: false,
		nav: true,
		navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
		navContainer: '#reviewCarousel-nav',
		responsive : {
			0 : {
				nav: false,
				dots: true
			},
			1000 : {
				dots: false,
				nav: true,
				navText: ['<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg-arrow"><use xlink:href="#svg-arrow-right"></use></svg></div>'],
				navContainer: '#reviewCarousel-nav'
			}
		}
	});

	detailCarousel();

	$('#btnLoadCatalog').click(function () {
		$(this).addClass('load');
		setTimeout(function () {
			$('#LoadCatalog').css('max-height','99999999999999999px');
			$('#LoadCatalog').slideDown();
			$('#btnLoadCatalog').hide();
		},600);
	});

	$(".clamp").dotdotdot({
		watch: "window"
	});

	$(".scroll").nanoScroller({
		paneClass: 'scroll-pane',
		sliderClass: 'scroll-slider',
		contentClass: 'scroll-content'
	});

	fResize();
	mobile();
});

$(window).on('resize',fResize);

function fResize() {
	setEqualHeight($(".info-autoheight"));
	mobile();
}

function setEqualHeight(columns) {
	$(columns).css('height','');
	var tallestcolumn = 0;
	columns.each( function() {
		var currentHeight = $(this).height();
		if(currentHeight > tallestcolumn) {
			tallestcolumn = currentHeight;
		}
	});
	columns.height(tallestcolumn);
}

function mobile() {
	var checkWidth = $(window).width();
	var advantagesCarousel = $('#advantagesCarousel');
	var partnersCarousel = $('#partnersCarousel');

	if (checkWidth > 1000) {
		advantagesCarousel.trigger('destroy.owl.carousel');
		advantagesCarousel.removeClass('owl-carousel');

		partnersCarousel.trigger('destroy.owl.carousel');
		partnersCarousel.removeClass('owl-carousel');

	} else if (checkWidth < 1000) {

		advantagesCarousel.addClass('owl-carousel');
		advantagesCarousel.owlCarousel({
			loop:false,
			items: 2,
			margin: 0,
			stagePadding: 0,
			smartSpeed: 600,
			dots: true,
			nav: false,
			responsive : {
				0 : {
					items: 1
				},
				600 : {
					items: 2
				}
			}
		});

		partnersCarousel.addClass('owl-carousel');
		partnersCarousel.owlCarousel({
			loop:false,
			items: 2,
			margin: 0,
			stagePadding: 0,
			smartSpeed: 600,
			dots: true,
			nav: false,
			responsive : {
				0 : {
					items: 1
				},
				600 : {
					items: 2
				}
			}
		});
	}
}

function detailCarousel() {
	detailCarousel = $('.detailCarousel, .about-carousel');
	detailCarousel.owlCarousel({
		items: 1,
		margin: 0,
		stagePadding: 0,
		smartSpeed: 600,
		loop: true,
		dots: true,
		nav: true,
		navText: ['<div class="pos-center"><svg class="svg svg-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-arrow-left"></use></svg></div>','<div class="pos-center"><svg class="svg svg-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-arrow-right"></use></svg></div>'],
		responsive: {
			0: {
				dots: true,
				nav: false
			},
			600: {
				dots: false,
				nav: true
			}
		}
	});
}

var Share = {
    /**
     * Показать пользователю дилог шаринга в сооветствии с опциями
     * Метод для использования в inline-js в ссылках
     * При блокировке всплывающего окна подставит нужный адрес и ползволит браузеру перейти по нему
     *
     * @example <a href="" onclick="return share.go(this)">like+</a>
     *
     * @param Object _element - элемент DOM, для которого
     * @param Object _options - опции, все необязательны
     */
     go: function(_element, _options) {
        var
            self = Share,
            link,
            options = $.extend(
                {
                    type:       'vk',                  // тип соцсети
                    url:        location.href,         // какую ссылку шарим
                    count_url:  location.href,         // для какой ссылки крутим счётчик
                    title:      param('title'),        // заголовок шаринга
                    image:      param('image'),        // картинка шаринга
                    text:       param('description'),  // текст шаринга
                },
                $(_element).data(), // Если параметры заданы в data, то читаем их
                _options            // Параметры из вызова метода имеют наивысший приоритет
            );

        if (self.popup(link = self[options.type](options)) === null) {
            // Если не удалось открыть попап
            if ( $(_element).is('a') ) {
                // Если это <a>, то подставляем адрес и просим браузер продолжить переход по ссылке
                $(_element).prop('href', link);
                return true;
            }
            else {
                // Если это не <a>, то пытаемся перейти по адресу
                location.href = link;
                return false;
            }
        }
        else {
            // Попап успешно открыт, просим браузер не продолжать обработку
            return false;
        }

        function param(name) {
            return $('meta[property=og\\:' + name + ']').attr('content');
        }
    },

    // ВКонтакте
    vk: function(_options) {
        var options = $.extend({
                url:    location.href,
                title:  document.title,
                image:  '',
                text:   '',
            }, _options);

        return 'http://vkontakte.ru/share.php?'
            + 'url='          + encodeURIComponent(options.url)
            + '&title='       + encodeURIComponent(options.title)
            + '&description=' + encodeURIComponent(options.text)
            + '&image='       + encodeURIComponent(options.image)
            + '&noparse=true';
    },

    // Одноклассники
    ok: function(_options) {
        var options = $.extend({
                url:    location.href,
                text:   '',
            }, _options);

        return 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1'
            + '&st.comments=' + encodeURIComponent(options.text)
            + '&st._surl='    + encodeURIComponent(options.url);
    },

    // Facebook
    fb: function(_options) {
        var options = $.extend({
                url:    location.href,
                title:  document.title,
                image:  '',
                text:   '',
            }, _options);

        return 'http://www.facebook.com/sharer.php?s=100'
            + '&p[title]='     + encodeURIComponent(options.title)
            + '&p[summary]='   + encodeURIComponent(options.text)
            + '&p[url]='       + encodeURIComponent(options.url)
            + '&p[images][0]=' + encodeURIComponent(options.image);
    },

    // Живой Журнал
    lj: function(_options) {
        var options = $.extend({
                url:    location.href,
                title:  document.title,
                text:   '',
            }, _options);

        return 'http://livejournal.com/update.bml?'
            + 'subject='        + encodeURIComponent(options.title)
            + '&event='         + encodeURIComponent(options.text + '<br/><a href="' + options.url + '">' + options.title + '</a>')
            + '&transform=1';
    },

    // Твиттер
    tw: function(_options) {
        var options = $.extend({
                url:        location.href,
                count_url:  location.href,
                title:      document.title,
            }, _options);

        return 'http://twitter.com/share?'
            + 'text='      + encodeURIComponent(options.title)
            + '&url='      + encodeURIComponent(options.url)
            + '&counturl=' + encodeURIComponent(options.count_url);
    },

    // Mail.Ru
    mr: function(_options) {
        var options = $.extend({
                url:    location.href,
                title:  document.title,
                image:  '',
                text:   '',
            }, _options);

        return 'http://connect.mail.ru/share?'
            + 'url='          + encodeURIComponent(options.url)
            + '&title='       + encodeURIComponent(options.title)
            + '&description=' + encodeURIComponent(options.text)
            + '&imageurl='    + encodeURIComponent(options.image);
    },

    // Открыть окно шаринга
    popup: function(url) {
        return window.open(url,'','toolbar=0,status=0,scrollbars=1,width=626,height=436');
    }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/common.js
 **/